import req from "../../../services/psikotest/request";

class EppsFormulaNorma {
  async list() {
    try {
      const res = await req.get("/api/psikotest_system/epps_formula_norma/");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async create(data: TPSEppsFormulaNorma) {
    try {
      const res = await req.post("/api/psikotest_system/epps_formula_norma/", data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async update(id: number, data: TPSEppsFormulaNorma) {
    try {
      const res = await req.put("/api/psikotest_system/epps_formula_norma/" + id, data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async delete(id: number) {
    try {
      const res = await req.delete("/api/psikotest_system/epps_formula_norma/" + id);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default EppsFormulaNorma;
